import React, { useRef, useState, useEffect } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";

import "./BlogsCarousel.scss";

export default function BlogsCarousel() {
  let carouselNumber = 2;
  let screenWidth = window.screen.width;

  if (screenWidth <= 672) {
    carouselNumber = 1;
  }
  const changeCarouselNumber = (e) => {
    if (window.innerWidth <= 672) {
      carouselNumber = 1;
    } else {
      carouselNumber = 2;
    }
  };
  useEffect(() => {
    let eventId = window.addEventListener("resize", changeCarouselNumber);
    return () => {
      window.removeEventListener("resize", changeCarouselNumber);
    };
  }, []);

  return (
    <div className="blog_carousel">
      <h3 className="carousel_title">Latest Blogs</h3>
      <Swiper watchSlidesProgress={true} slidesPerView={carouselNumber} className="mySwiper">
        <SwiperSlide>
          <div className="custom_card carousel_card">
            <div className="card_header">
              <img src="card_image1.jpg" alt="bookmark" />
            </div>
            <div className="card_body">
              <h4 className="card_title">Start of something new.</h4>
              <p className="card_date">03 Nov 2022</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="custom_card carousel_card">
            <div className="card_header">
              <img src="card_image2.png" alt="bookmark" />
            </div>
            <div className="card_body">
              <h4 className="card_title">Start of something new.</h4>
              <p className="card_date">03 Nov 2022</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="custom_card carousel_card">
            <div className="card_header">
              <img src="card_image.png" alt="bookmark" />
            </div>
            <div className="card_body">
              <h4 className="card_title">Start of something new.</h4>
              <p className="card_date">03 Nov 2022</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="custom_card carousel_card">
            <div className="card_header">
              <img src="card_image3.jpg" alt="bookmark" />
            </div>
            <div className="card_body">
              <h4 className="card_title">Start of something new.</h4>
              <p className="card_date">03 Nov 2022</p>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
